import { Component } from '@angular/core';

@Component({
    selector: 'campaign-success-card-page',
    templateUrl: './campaign-success-card.page.html'
})
export class CampaignSuccessCardPage {

}